import { useEffect } from 'react';

// react-router components
import { useLocation, Outlet } from 'react-router-dom';

// @mui material components
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { useMaterialUIController } from 'context';

// Self designed sub pages, compoenents and others
import MDBox from 'components/MDBox';
import Grid from '@mui/material/Grid2';
import Sidenav from './Sidenav';

// themes
import theme from 'assets/theme';

// Images
import logger from 'utils/logger';

const AdminDashboard = () => {
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;

  const log = logger.createLogger('AdminDashboard');

  const { pathname } = useLocation();

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Sidenav color={sidenavColor} />
      <MDBox
        data-testid="dashboard-layout-box"
        sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
          p: 3,
          [breakpoints.up('xs')]: {
            marginLeft: pxToRem(274),
            marginRight: pxToRem(16), // Since the sidenav is always open
            transition: transitions.create(['margin-left', 'margin-right'], {
              easing: transitions.easing.easeInOut,
              duration: transitions.duration.standard,
            }),
          },
        })}>
        <Grid
          data-testid="dashboard-layout-grid-container"
          container
          direction="row"
          alignItems="stretch"
          justifyContent="center">
          <Grid size={12} data-testid="dashboard-layout-grid-left">
            <Outlet />
          </Grid>
        </Grid>
      </MDBox>
    </ThemeProvider>
  );
};

export default AdminDashboard;
